import api from "../../config/client.axios.api";

export const getAllMachineUserApiRequest = async () => {
  const response = await api.get(`/machine/machine-of-account`);
  return response.data;
};
